// Solution/Product section configuration
// Defines fields for describing the startup's product or service
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for solution section
export const solutionSectionSchema = z.object({
  productDescription: z.string().min(1, 'Este campo es requerido'),
  howItWorks: z.string().min(1, 'Este campo es requerido'),
  mainValue: z.string().min(1, 'Este campo es requerido'),
  differentiation: z.string().min(1, 'Este campo es requerido'),
});

export type SolutionSectionData = z.infer<typeof solutionSectionSchema>;

// Section config
export const solutionSection: SectionConfig = {
  id: 'solution',
  titleKey: 'Solución / Producto',
  descriptionKey: 'Describe tu producto o servicio y su propuesta de valor',
  validationSchema: solutionSectionSchema,
  fields: [
    {
      name: 'productDescription',
      type: 'textarea',
      label: 'Describe tu producto o servicio',
      placeholder: 'Explica qué es tu producto o servicio...',
      required: true,
    },
    {
      name: 'howItWorks',
      type: 'textarea',
      label: '¿Cómo funciona tu solución?',
      placeholder: 'Describe el funcionamiento de tu solución...',
      required: true,
    },
    {
      name: 'mainValue',
      type: 'textarea',
      label: '¿Qué valor principal entregas al usuario?',
      placeholder: 'Describe el valor que aportas...',
      required: true,
    },
    {
      name: 'differentiation',
      type: 'textarea',
      label: '¿En qué se diferencia de otras soluciones?',
      placeholder: 'Explica tu diferenciación...',
      required: true,
    },
  ],
};
